import React from "react";

class ViewToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedView: props.defaultSelected || "Top Lists", // Default selected
    };
  }

  handleToggle = (view) => {
    //this.setState({ selectedView: view });
    this.props.onToggle && this.props.onToggle(view); // Send value to parent if needed
  };

  render() {
    const { selectedView } = this.state;

    return (
      <div className="toggle-wrapper">
        <div className="toggle-container">
          <button
            className={`toggle-button ${
              selectedView === "Map View" ? "active" : ""
            }`}
            onClick={() => this.handleToggle("Map View")}
          >
            Map View
          </button>
          <button
            className={`toggle-button ${
              selectedView === "Top Lists" ? "active" : ""
            }`}
            onClick={() => this.handleToggle("Top Lists")}
          >
            Top Lists
          </button>
        </div>
      </div>
    );
  }
}

export default ViewToggle;
